export interface TickerItem {
  id: number;
  time: string;
  tag: string;
  text: string;
}

export interface HotItem {
  id: number;
  title: string;
  excerpt: string;
  tag: string;
  image: string;
  time: string;
  heat: string;
}

export interface MiniItem {
  id: number;
  title: string;
  tag: string;
  count: string;
  icon: string;
}

export interface OnsiteItem {
  id: number;
  title: string;
  excerpt: string;
  image: string;
  tag: string;
  place: string;
  time: string;
  heat: string;
  bullets: string[];
}

export interface GuideStep {
  id: number;
  step: string;
  title: string;
  desc: string;
  icon: string;
}

export interface FaqItem {
  id: number;
  question: string;
  answer: string;
}

export const heroStats = [
  { id: 1, value: '128', unit: '条', label: '今日速递' },
  { id: 2, value: '36', unit: '组', label: '现场图集' },
  { id: 3, value: '24.6', unit: '万', label: '今日围观' },
  { id: 4, value: '5', unit: '分钟', label: '平均更新间隔' },
];

export const tickerItems: TickerItem[] = [
  { id: 1, time: '09:12', tag: '片场', text: '某剧组深夜收工现场图流出，工作人员回应：只是按计划补拍' },
  { id: 2, time: '09:48', tag: '综艺', text: '新一季综艺录制路透更新，嘉宾阵容再添两位新面孔' },
  { id: 3, time: '10:20', tag: '舞台', text: '巡演彩排花絮曝光，灯光舞美整体升级，座位图同步调整' },
  { id: 4, time: '10:55', tag: '定档', text: '本月待播清单汇总：四部新剧集中在月中前后上线' },
  { id: 5, time: '11:30', tag: '后台', text: '品牌活动后台照流出，造型团队回应了发型变化的原因' },
  { id: 6, time: '12:06', tag: '行程', text: '粉丝拍摄的机场图更新，公开行程节奏明显加快' },
  { id: 7, time: '12:40', tag: '回应', text: '针对网传片段，相关工作室发布简短说明，未补充更多细节' },
  { id: 8, time: '13:15', tag: '现场', text: '体育馆外围搭建进入收尾，舞台主体结构已可辨认' },
];

export const hotspotFeature: HotItem = {
  id: 1,
  title: '本周吃瓜观察：从片场路透到舞台花絮，现场信息到底该怎么追',
  excerpt:
    '这一周的新料明显集中在「现场」两个字上：片场收工、节目录影、巡演彩排，几乎每一个方向都能翻出可看的图文。与其被零散标题牵着走，不如先把现场时间线理清楚，再回头对照后面的更新。',
  tag: '本周主推',
  image:
    'https://readdy.ai/api/search-image?query=abstract%20editorial%20scene%20of%20backstage%20corridor%20with%20warm%20amber%20light%20and%20crimson%20velvet%20curtain%20shadows%2C%20cinematic%20still%20life%2C%20grainy%20film%20texture%2C%20mysterious%20mood%2C%20no%20people&width=1200&height=900&seq=heliao51-hot-feature-02&orientation=landscape',
  time: '今天 13:20 更新',
  heat: '3.2万 围观',
};

export const hotspotSmalls: HotItem[] = [
  {
    id: 2,
    title: '录音棚外的一次偶遇，把整条时间线串了起来',
    excerpt: '门口进出节奏、车次时间点，和此前公开行程基本对得上。',
    tag: '行程线',
    image:
      'https://readdy.ai/api/search-image?query=close-up%20stylized%20studio%20microphone%20and%20sound%20waves%20in%20warm%20amber%20light%2C%20editorial%20still%20life%2C%20minimal%20dark%20background%2C%20grainy%20texture&width=600&height=600&seq=heliao51-hot-s1-03&orientation=squarish',
    time: '今天 12:05',
    heat: '1.4万',
  },
  {
    id: 3,
    title: '一张后台合照，引出造型团队的新合作',
    excerpt: '画面里的细节不多，但工作人员标签和物料顺序很有信息量。',
    tag: '物料线',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20glowing%20smartphone%20screen%20in%20a%20dark%20room%20with%20crimson%20light%2C%20editorial%20illustration%2C%20grainy%20texture%2C%20minimal%20composition&width=600&height=600&seq=heliao51-hot-s2-04&orientation=squarish',
    time: '今天 11:32',
    heat: '9800',
  },
];

export const miniItems: MiniItem[] = [
  { id: 1, title: '定档与撤档清单', tag: '档期', count: '12 条更新', icon: 'ri-calendar-schedule-line' },
  { id: 2, title: '巡演城市与场次', tag: '舞台', count: '8 条更新', icon: 'ri-music-2-line' },
  { id: 3, title: '品牌活动排期', tag: '商务', count: '9 条更新', icon: 'ri-store-2-line' },
  { id: 4, title: '公开行程汇总', tag: '行程', count: '15 条更新', icon: 'ri-route-line' },
  { id: 5, title: '工作室回应合集', tag: '回应', count: '6 条更新', icon: 'ri-megaphone-line' },
  { id: 6, title: '待播剧集进度', tag: '剧集', count: '11 条更新', icon: 'ri-movie-2-line' },
];

export const onsiteItems: OnsiteItem[] = [
  {
    id: 1,
    title: '夜戏收工现场：灯光组的收工流程被完整记录',
    excerpt:
      '从收灯、卷线到车辆离场，整段流程拍得比较完整。对照此前公布的拍摄周期可以看出，这一轮补拍基本在计划内，没有出现临时改景的情况。',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20night%20street%20scene%20with%20neon%20reflections%20on%20wet%20pavement%2C%20crimson%20and%20amber%20tones%2C%20cinematic%20grainy%20texture%2C%20no%20people&width=900&height=700&seq=heliao51-onsite-1-07&orientation=landscape',
    tag: '现场直击',
    place: '横店片场',
    time: '今天 09:12',
    heat: '2.1万围观',
    bullets: ['收工时间与本周期排期一致', '现场无临时改景记录', '车辆离场顺序被完整拍下'],
  },
  {
    id: 2,
    title: '录影棚换景间隙：后台动线被路透镜头捕捉',
    excerpt:
      '换景的十几分钟里，棚内进出频次明显变高。路透画面能看到舞台侧面的道具摆放顺序，和上一季相比调整了将近一半，应该是为新环节做的准备。',
    image:
      'https://readdy.ai/api/search-image?query=stylized%20television%20studio%20set%20with%20warm%20lighting%20and%20empty%20chairs%2C%20editorial%20cinematic%20scene%2C%20deep%20amber%20and%20crimson%20tones%2C%20grainy%20texture&width=900&height=700&seq=heliao51-onsite-2-08&orientation=landscape',
    tag: '有图有料',
    place: '综艺录影棚',
    time: '今天 09:48',
    heat: '1.7万围观',
    bullets: ['道具摆放顺序有新调整', '换景窗口约十二分钟', '现场座位图有小幅改动'],
  },
  {
    id: 3,
    title: '巡演彩排首日：舞台主体结构搭建过程曝光',
    excerpt:
      '从外围搭建到主结构成型，进度比对外公布的日程略早。灯位预留和升降台位置都能在画面里辨认出来，后续的彩排时间大概率会提前。',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20long%20exposure%20traffic%20light%20trails%20at%20night%20in%20warm%20red%20and%20gold%20tones%2C%20cinematic%20grainy%20texture%2C%20dark%20moody%20atmosphere&width=900&height=700&seq=heliao51-onsite-3-09&orientation=landscape',
    tag: '边拍边更',
    place: '城市中心体育馆',
    time: '今天 10:20',
    heat: '1.2万围观',
    bullets: ['搭建进度略早于公开日程', '灯位预留位置可辨认', '彩排时间或将提前一天'],
  },
];

export const guideSteps: GuideStep[] = [
  {
    id: 1,
    step: '01',
    title: '先扫速递条',
    desc: '页面顶部的速递条按时间滚动，几十秒就能过一遍当天的新料标题，先建立大概印象。',
    icon: 'ri-speed-up-line',
  },
  {
    id: 2,
    step: '02',
    title: '再进热点区',
    desc: '大卡看本周主推方向，小卡补细节线索。大小卡混排的好处是：先看主干，再决定要不要深挖。',
    icon: 'ri-layout-masonry-line',
  },
  {
    id: 3,
    step: '03',
    title: '最后对现场',
    desc: '现场爆料按地点和时间排列，图文对照着看，比单看一段文字描述更容易判断真伪。',
    icon: 'ri-camera-lens-line',
  },
];

export const faqItems: FaqItem[] = [
  {
    id: 1,
    question: '黑料51 主要更新哪些方向的内容？',
    answer:
      '以黑料51吃瓜热点和黑料51现场爆料两条线为主：一条是当天热度较高的讨论方向，一条是可对照的现场图文。除此之外还会有档期、行程、回应类的小条目作为补充。',
  },
  {
    id: 2,
    question: '新料速递多久更新一次？',
    answer:
      '速递条按当天情况滚动叠加，空档期可能几十分钟没有新条目，热点集中时则会连着补好几条。页面上的时间戳就是该条内容进入速递的顺序。',
  },
  {
    id: 3,
    question: '现场爆料的图片是从哪里来的？',
    answer:
      '页面展示的是公开流传的画面与汇总描述，仅用于整理时间线。我们不提供下载，也不对画面之外的细节做推断，涉及个人判断的部分请以当事方说明为准。',
  },
  {
    id: 4,
    question: '为什么有些条目只有文字描述？',
    answer:
      '部分方向暂时没有可对照的画面，出于谨慎只做文字整理，不做配图。等有可核对的现场素材之后，会补进对应的现场爆料分区。',
  },
  {
    id: 5,
    question: '怎样才算跟着看现场？',
    answer:
      '建议按「速递条 → 热点区 → 现场爆料」的顺序看：先知道今天发生了什么，再看主推方向，最后回到现场图文核对细节。整个过程五分钟以内可以完成。',
  },
];